<template>
  <div>
    <v-text-field
      v-model="location.formatted_address"
      label="Physical Location"
      prepend-inner-icon="mdi-map-marker"
      outlined
      readonly
      @click.stop="dialog = true"
      clearable
      @click:clear="clearLocation"
    ></v-text-field>

    <v-dialog v-model="dialog" width="900">
      <v-card>
        <v-card-title class="headline grey lighten-2 pa-3">
          Physical Location
        </v-card-title>
        <v-card-text class="">
          <local-map
            :latitude="latitude"
            :longitude="longitude"
            :zoom="zoom"
            @newLocation="newLocation"
          />
          <v-banner class="success" dark>
            <span>
              {{ `Address: ${location.formatted_address || ""}` }}
            </span>
            <br />
            <span>
              {{
                `Latitude: ${location.lat}, Longitude: ${location.lng}`
              }}</span
            ></v-banner
          >
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="dialog = false">
            close
          </v-btn>
          <v-btn
            :disabled="
              !location.formatted_address || !location.lat || !location.lng
            "
            color="primary"
            @click="dialog = false"
          >
            done
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import mapstyle from "@/assets/js/mapstyle";
import { mapGetters } from "vuex";
const LocalMap = {
  name: "LocalMap",
  props: {
    latitude: {
      type: Number,
      default: 0,
    },
    longitude: {
      type: Number,
      default: 0,
    },
    zoom: {
      type: Number,
      default: 15,
    },
  },
  data: () => ({
    place: "",
  }),
  mounted() {
    const self = this;
    let initialLatlng = new google.maps.LatLng(this.latitude, this.longitude);
    // Options
    let mapOptions = {
      center: initialLatlng,
      zoom: 15,
      styles: mapstyle,
    };

    // Apply options
    this.map = new google.maps.Map(
      document.getElementById("latlng-picker"),
      mapOptions
    );
    this.geocoder = new google.maps.Geocoder();
    this.infowindow = new google.maps.InfoWindow();
    // Create search bar autocomplete
    this.autocomplete = new google.maps.places.Autocomplete(
      this.$refs.input,
      Object.assign({
        // componentRestrictions: { country: ["us", "uk", "za"] },
        types: [],
      })
    );
    this.autocomplete.setFields(["geometry", "formatted_address", "name"]);
    this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(
      this.$refs.input
    );
    this.autocomplete.addListener("place_changed", this.moveMarker);
    // Add marker
    this.marker = new google.maps.Marker({
      position: initialLatlng,
      map: this.map,
    });
    this.marker.setMap(this.map);
    this.map.addListener("dragend", async (e) => {
      let lat = this.map.getCenter().lat();
      let lng = this.map.getCenter().lng();
      let newLgnLat = { lat: lat, lng: lng };
      const reversePlace = await self.reverseGeoCode(newLgnLat);
      this.setMarkerandEmit(newLgnLat, reversePlace);
    });

    this.map.addListener("center_changed", async (e) => {
      let lat = this.map.getCenter().lat();
      let lng = this.map.getCenter().lng();
      let newLgnLat = { lat: lat, lng: lng };
      self.marker.setPosition(newLgnLat);
    });

    google.maps.event.trigger(this.map, "resize");
  },
  methods: {
    moveMarker() {
      var place = this.autocomplete.getPlace();
      var locationObject = place.geometry && place.geometry.location;
      if (locationObject) {
        let newLgnLat = {
          lat: locationObject.lat(),
          lng: locationObject.lng(),
        };
        this.map.panTo(newLgnLat);
        this.setMarkerandEmit(newLgnLat, place);
      }
    },
    setMarkerandEmit(location, place) {
      const self = this;
      self.place = place;
      self.marker.setPosition(location);
      // self.infowindow.setContent(place.formatted_address);
      // self.infowindow.open(self.map, self.marker);
      self.$refs.input.value = place.formatted_address;
      self.$emit("newLocation", {
        ...location,
        ...self.place,
      });
    },
    async reverseGeoCode(latlng) {
      const self = this;
      return new Promise((resolve, reject) => {
        self.geocoder.geocode({ location: latlng }, (results, status) => {
          if (status === "OK") {
            resolve(results[0]);
          } else {
            reject(status);
          }
        });
      });
    },
  },
  render() {
    return (
      <div id="latlng-picker" class="latlng-picker">
        <div class="latlng-picker__map"></div>
        <input type="text" class="latlng-picker__autocomplete" ref="input" />
      </div>
    );
  },
};

export default {
  name: "MapLocationPicker",
  components: {
    LocalMap,
  },
  props: {
    latitude: {
      type: Number,
      default: 0,
    },
    longitude: {
      type: Number,
      default: 0,
    },
    zoom: {
      type: Number,
      default: 15,
    },
  },
  data() {
    return {
      dialog: false,
      location: {
        lat: this.latitude,
        lng: this.longitude,
        formatted_address: "",
      },
    };
  },
  mounted() {},
  methods: {
    newLocation(location) {
      this.location = location;
      this.$emit("locationUpdated", location);
    },
    clearLocation() {
      this.$emit("clearLocation");
    },
  },
};
</script>

<style lang="sass">
.latlng-picker__autocomplete
  padding: 8px 14px
  margin: 10px
  width: 50%
  min-width: 300px
  font-size: 18px
  font-weight: 300
  text-overflow: ellipsis
  border: 2px solid #005cff
  background-color: #fff
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3)

.latlng-picker
  height: 400px
</style>
